import { Component, Vue } from 'vue-property-decorator'
import { sprintf } from 'sprintf-js'

import CAOG1030Service from './CAOG1030Service'
import CAOG1030ViewModel from './CAOG1030ViewModel'
import CAOG1030ParamModel from './CAOG1030ParamModel'

import Store from '@/common/utils/Store'
import ValidationUtils from '@/common/utils/ValidationUtil'
import CommonUtil from '@/common/utils/CommonUtil'
import { createAccordion } from '@/common/utils/CreateAccordion'

// vue components
import Pagination from '@/components/pagination/Pagination.vue'
import CategoryIcon from '@/components/icons/components/category-icon.vue'

import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import { fixedContentNoLogin } from '@/assets/js/main.js'
import CommonConstants from '@/common/CommonConstants'
@Component({
  name: 'CAOG1030',
  components: {
  Pagination,
  CategoryIcon
  }
  })

// 「」
export default class CAOG1030Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private PAGE_SIZE = 10
  private FORMAT_TITLE_RESULT_SEARCH = '%s%s%sに関する検索結果：%d件'
  private KEYWORD_MAX_LENGTH = 40

  private NO_RECORD = '該当する質問がありません。'

  private QUESTION_DIV_IDECO = '2'
  private QUESTION_DIV_COMPANY = '1'

  private caog1030Service: CAOG1030Service = new CAOG1030Service()
  private caog1030paramModel: CAOG1030ParamModel = this.$route
    .params as CAOG1030ParamModel

  private caog1030ViewModel: CAOG1030ViewModel = {
    catInfoLst: new Array(6).fill({
      classId: null,
      classMei: ''
    }),
    searchKeyword: '',
    searchCategoryId: null,
    searchCategory: '',
    totalRecord: null,
    qaInfoLst: [
      {
        classId: null,
        title: '',
        memo: '',
        type: ''
      }
    ],
    filteredQaLst: [
      {
        classId: null,
        title: '',
        memo: '',
        type: ''
      }
    ],
    qaInSelectedPageLst: [
      {
        classId: null,
        title: '',
        memo: '',
        type: ''
      }
    ],
    currentPage: 1,
    titleResult: '',
    activeCategory: null,
    message: ''
  }

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContentNoLogin()
    await this.init()
    this.$root.$emit('renderTabIndexPage', '')
    this.$root.$emit('renderEvent', '')
  }

  /**
   * 初期処理
   */
  private async init() {
    const caoa1030ResponseModel = await this.caog1030Service.callAPICAAOA1030()
    const keyCatId = +this.caog1030paramModel?.keyCatId
    const searchKeyword = this.caog1030paramModel?.searchKeyword
    let searchCategoryId = null as any
    let searchCategory = null as any

    if (CommonUtil.isNotEmpty(keyCatId)) {
      searchCategoryId = keyCatId
      this.caog1030ViewModel.activeCategory = keyCatId
    }

    if (CommonUtil.isNotEmpty(searchKeyword)) {
      this.caog1030ViewModel.searchKeyword = searchKeyword
    }

    const catInfoLst = caoa1030ResponseModel.catInfoLst
    const qaInfoLst = caoa1030ResponseModel.qaInfoLst
    if (searchCategoryId) {
      searchCategory = this.caog1030Service.getCategoryNameById(
        searchCategoryId,
        catInfoLst
      )
    }

    const faqFilterLst = this.caog1030Service.filterQuestion(
      null,
      qaInfoLst ?? null,
      ''
    )

    if (CommonUtil.isNotEmpty(qaInfoLst)) {
      qaInfoLst.map((item) => {
        item.memo = item.memo?.replaceAll(
          CommonConstants.REGEX_LINE_BREAK,
          '<br/>'
        )

        return {
          ...item
        }
      })

      this.caog1030ViewModel.qaInfoLst = qaInfoLst
    } else {
      this.caog1030ViewModel.qaInfoLst = null
      this.caog1030ViewModel.message = this.NO_RECORD
    }
    this.caog1030ViewModel.catInfoLst = CommonUtil.isNotEmpty(
      caoa1030ResponseModel.catInfoLst
    )
      ? caoa1030ResponseModel.catInfoLst
      : null
    this.caog1030ViewModel.searchCategoryId = searchCategoryId
    this.caog1030ViewModel.searchCategory = searchCategory
    this.caog1030ViewModel.totalRecord = faqFilterLst?.length
    this.caog1030ViewModel.filteredQaLst = faqFilterLst
    this.caog1030ViewModel.qaInSelectedPageLst = faqFilterLst?.slice(
      0,
      this.PAGE_SIZE
    )

    this.clickSearchButton()
  }

  /**
   * よくあるご質問カテゴリボタン押下
   * @param id
   */
  private clickCategoryButton(id) {
    let categoryId = id
    this.caog1030ViewModel.activeCategory =
      this.caog1030ViewModel.activeCategory === categoryId ? null : categoryId

    this.caog1030paramModel = null

    if (!this.caog1030ViewModel.activeCategory) categoryId = null

    if (categoryId === null) {
      this.caog1030ViewModel.searchCategoryId = null as any
      this.caog1030ViewModel.searchCategory = null
    } else if (categoryId) {
      const searchCategory = this.caog1030Service.getCategoryNameById(
        categoryId,
        this.caog1030ViewModel.catInfoLst
      )
      this.caog1030ViewModel.searchCategoryId = categoryId
      this.caog1030ViewModel.searchCategory = searchCategory
    }

    this.clickSearchButton()
  }

  /**
   * 検索ボタン押下
   */
  private clickSearchButton() {
    const isMaxLengthValid = ValidationUtils.isMaxLengthValid(
      this.KEYWORD_MAX_LENGTH,
      this.caog1030ViewModel.searchKeyword
    )
    if (isMaxLengthValid === false) {
      const errorMessage = []
      errorMessage.push({
        code: 'MSGCAOG1030WF001',
        message: CommonUtil.getMessage('MSGCAOG1030WF001', []),
        url: ''
      })
      return Store.setResponseErrors(errorMessage)
    } else {
      Store.setResponseErrors([])
      const filteredQaLst = this.caog1030Service.filterQuestion(
        this.caog1030ViewModel.searchCategoryId,
        this.caog1030ViewModel.qaInfoLst,
        this.caog1030ViewModel.searchKeyword
      )
      this.caog1030ViewModel.filteredQaLst = filteredQaLst

      const qaInSelectedPageLst = filteredQaLst?.slice(0, this.PAGE_SIZE)
      this.caog1030ViewModel.qaInSelectedPageLst = qaInSelectedPageLst
      this.caog1030ViewModel.currentPage = 1
      this.caog1030ViewModel.totalRecord = filteredQaLst?.length
    }
    this.caog1030ViewModel.message = this.NO_RECORD

    const searchKeyword = this.caog1030ViewModel.searchKeyword
    const searchCategory = this.caog1030ViewModel.searchCategory

    let strCatetory = ''
    let strNo = ''
    let strSearchKeyword = ''

    if (searchCategory === null) {
      strCatetory = 'すべてのカテゴリー'
    } else if (searchKeyword) {
      strCatetory = 'カテゴリー「' + searchCategory + '」'
    } else {
      strCatetory = '「' + searchCategory + '」'
    }

    if (searchKeyword) {
      strNo = searchCategory !== null ? 'のキーワード' : 'の'
      strSearchKeyword = '「' + searchKeyword + '」'
    }

    this.caog1030ViewModel.titleResult = sprintf(
      this.FORMAT_TITLE_RESULT_SEARCH,
      strCatetory,
      strNo,
      strSearchKeyword,
      this.caog1030ViewModel.filteredQaLst?.length || 0
    )

    this.$nextTick(() => {
      createAccordion()
      this.$root.$emit('renderTabIndexPage', '')
      this.$root.$emit('renderEvent', '')
    })
  }

  /**
   * ページ数リンク押下
   * @param selectedPage
   */
  private changePage(selectedPage) {
    const qaInSelectedPageLst = this.caog1030ViewModel.filteredQaLst.slice(
      (selectedPage - 1) * this.PAGE_SIZE,
      selectedPage * this.PAGE_SIZE
    )
    this.caog1030ViewModel.qaInSelectedPageLst = qaInSelectedPageLst
    this.caog1030ViewModel.currentPage = selectedPage
    createAccordion()
    this.$root.$emit('renderTabIndexPage', '')
    this.$root.$emit('renderEvent', '')
  }

  /**
   * ログインに戻るボタン押下
   */

  private backToLogin() {
    this.$router.push({ name: 'caag1010' })
  }
}
